import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const MobilityModuleFooter = () => {
    const { t } = useTranslation(['mobilityModuleDetails']);

    return (
        <Button form="updateMainDetails" htmlType="submit" type="primary">
            {t('mobilityModuleDetails:actions.update')}
        </Button>
    );
};

export default MobilityModuleFooter;
